// Path: libs/core/shell/src/lib/layout/public/hero/hero-card/hero-card.component.ts
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';

@Component({
  selector: 'lib-hero-card',
  templateUrl: './hero-card.component.html',
  styleUrl: './hero-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeroCardComponent {
  readonly badge = input<string | null>(null);
  readonly title = input.required<string>();
  readonly description = input<string | null>(null);

  readonly price = input<number | null>(null);
  readonly compareAtPrice = input<number | null>(null);

  readonly ctaLabel = input<string>('Ver oferta');

  readonly imageUrl = input<string | null>(null);
  readonly imageAlt = input<string>('');

  readonly clickable = input<boolean>(true);

  readonly cardPressed = output<void>();
  readonly actionPressed = output<void>();

  protected readonly hasImage = computed(() => !!this.imageUrl()?.trim());

  protected readonly resolvedImageAlt = computed(
    () => this.imageAlt().trim() || this.title()
  );

  protected readonly showPrice = computed(() => this.price() !== null);

  protected readonly showComparePrice = computed(() => {
    const current = this.price();
    const compare = this.compareAtPrice();

    return (
      current !== null &&
      compare !== null &&
      Number.isFinite(current) &&
      Number.isFinite(compare) &&
      compare > current
    );
  });

  protected onCardClick(): void {
    if (!this.clickable()) return;
    this.cardPressed.emit();
  }

  protected onCardKeydown(event: KeyboardEvent): void {
    if (!this.clickable()) return;

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.cardPressed.emit();
    }
  }

  protected onActionClick(event: Event): void {
    event.stopPropagation();
    this.actionPressed.emit();
  }
}